"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NibbySadSystemIcon = exports.NibbyHappySystemIcon = exports.NibbySadGraphicIcon = exports.NibbyHappyGraphicIcon = void 0;
var nibby_happy_1 = require("./graphic/nibby-happy");
Object.defineProperty(exports, "NibbyHappyGraphicIcon", {
  enumerable: true,
  get: function () {
    return nibby_happy_1.NibbyHappyGraphicIcon;
  }
});
var nibby_sad_1 = require("./graphic/nibby-sad");
Object.defineProperty(exports, "NibbySadGraphicIcon", {
  enumerable: true,
  get: function () {
    return nibby_sad_1.NibbySadGraphicIcon;
  }
});
var nibby_happy_2 = require("./system/nibby-happy");
Object.defineProperty(exports, "NibbyHappySystemIcon", {
  enumerable: true,
  get: function () {
    return nibby_happy_2.NibbyHappySystemIcon;
  }
});
var nibby_sad_2 = require("./system/nibby-sad");
Object.defineProperty(exports, "NibbySadSystemIcon", {
  enumerable: true,
  get: function () {
    return nibby_sad_2.NibbySadSystemIcon;
  }
});